import { Stack } from '@mui/material';
import CompetitorTreemap from 'src/features/CompanyDetail/Competitor/Treemap';
import CompetitorWorldMap from 'src/features/CompanyDetail/Competitor/Worlmap';

const Competitor = ({ company }: { company: ICompanyDetail }) => {
  return (
    <Stack spacing={3}>
      <CompetitorWorldMap company={company} />
      <CompetitorTreemap company={company} />
    </Stack>
  );
};

export default Competitor;
